import SVGIcon from "src/components/SVGIcon";

const ReOrderIcon = ({ title = "Reorder", ...props }) => {
  return (
    <SVGIcon viewBox="0 0 24 24" title={title} fill="none" {...props}>
      <path
        d="M18 9L12 3L6 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 15L12 21L18 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGIcon>
  );
};

export default ReOrderIcon;
